import { defineNuxtPlugin } from '#app'
import { debounce } from 'lodash'

export default defineNuxtPlugin((nuxtApp) => {
    if (!import.meta.client) {
        return
    }

    const handleTracking = (route) => {
        if (route.query.a || route.query.utm_source) {
            if (route.query.a) {
                useCookie('aff_id', { path: '/' }).value = route.query.a

                const querystring = route.fullPath.slice(1)
                useCookie('querystring', { path: '/' }).value = querystring
            }

            const trackingParams = [
                'a',
                'utm_source',
                'utm_medium',
                'utm_campaign',
                'utm_term',
                'utm_content',
                'pxl',
                'zoneid',
            ]

            trackingParams.forEach((param) => {
                if (route.query[param]) {
                    useCookie(param, { path: '/' }).value = route.query[param]
                }
            })

            if (process.env.NODE_ENV === 'development') {
                console.log('[Client] Tracking cookies set:', document.cookie)
            }
        }
    }

    const debouncedHandleTracking = debounce(handleTracking, 300)

    nuxtApp.hook('app:created', () => {
        const route = useRoute()
        debouncedHandleTracking(route)
    })

    nuxtApp.hook('page:finish', () => {
        const route = useRoute()
        debouncedHandleTracking(route)
    })
})
